












import { Prop, Vue, Component } from "@/shared/vuepack";
import Button from "@/shared/components/ui/Button.vue";
import UpfrontContributionBase from "@/employee/components/onboarding/upfront-contribution/UpfrontContributionBase.vue";
import ContributionsEdit from "@/shared/components/contributionsV3/ContributionsEdit.vue";
import { OnboardingBalanceTransfer } from "@/employee/route-names";
import { TransferSchedule } from "@/shared/types";

@Component({
  components: {
    Button,
    UpfrontContributionBase,
    ContributionsEdit
  }
})
export default class OnboardingScheduleContribution extends Vue {
  @Prop()
  id: number;

  @Prop()
  value: TransferSchedule;

  @Prop()
  routeToConfirmation: (schedule: TransferSchedule, isUpdate: boolean) => Location;

  onSkip () {
    this.$router.push({ name: OnboardingBalanceTransfer });
  }
}
